import { Component, Inject } from "@angular/core";
import { MatOptionSelectionChange } from "@angular/material/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { GraphQLError } from "graphql/error/GraphQLError";
import { AssignSolicitorToProjectGQL, SolicitorListForAssignmentGQL } from "../../../../../src/generated/graphql";
import { ProjectService } from "../../service/project.service";
import { SnackBarService } from "../../service/snack.bar.service";

export interface DialogData {

}

@Component({
  selector: "assgin-solicitor-dialog",
  templateUrl: "assgin-solicitor-dialog.html",
})
export class AssignSolicitorDialog {
  solicitorlist: any;
  projectId: string;
  solicitorIds: string[] = [];

  constructor(
    public dialogRef: MatDialogRef<AssignSolicitorDialog>,
    private solicitorListForAssignmentGQL: SolicitorListForAssignmentGQL,
    private snackBarService: SnackBarService,
    private assignSolicitorToProjectGQL: AssignSolicitorToProjectGQL,
    private projectService: ProjectService,
    @Inject(MAT_DIALOG_DATA) private data: DialogData) {
    this.projectId = this.projectService.Current;
    this.solicitorListForAssignmentGQL.fetch({ projectId: this.projectId }).subscribe((result) => {
      this.solicitorlist = result.data.solicitorListForAssignment;
      if (result?.errors) {
        this.snackBarService.showQueryError(result.errors);
      }
    })
  }

  selectedSolicitor(event: MatOptionSelectionChange) {
    if (event.source.selected) {
      this.solicitorIds.push(event.source.value);
    } else {
      this.solicitorIds = this.solicitorIds.filter(x => x != event.source.value);
    }
  }

  public submitForm() {
    if (this.solicitorIds.length > 0) {
      this.assignSolicitorToProjectGQL.mutate({ projectId: this.projectId, solicitor_appointed_id: this.solicitorIds })
        .subscribe((result) => {
          if (result) {
            this.snackBarService.show(`Assigned successfully`);
          }
          this.dialogRef.close();
        }, (err: GraphQLError) => {
          this.snackBarService.showMutationError(err);
        }

        )
    }
  }
}